import Vue from 'vue'

import { currency } from './currency'
import moment from 'moment'

Vue.filter('currency', currency)
Vue.filter('formatDate', function(value) {
    if (!value) return value
    //    return moment(String(value)).format('YYYY.MM.DD')
    //    return moment(String(value)).format('DD/MM/YYYY')
        return moment(String(value)).format('YYYY-MM-DD')
    })
Vue.filter('capitalize', function (value) {
    if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
    })
Vue.filter('summary', function (value) {
    if (!value) return ''
    value = value.toString()
    var content = new DOMParser().parseFromString(value, 'text/html').body.textContent || ""

    return content.substring(0,300)
})

export default {}
